import { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Container(): Components {
  return {
    MuiContainer: {
      styleOverrides: {
        root: {}
      }
    }
  };
}
